class BESSAppProjectEditorMapField extends BESSAppProjectEditorInput {

    initialise() {
        super.initialise();
        this.view.parents('td').addClass('app-project-editor-map-field');
    }

    setValue(value) {
        super.setValue(value);
        let mapComponentNode = this.view.find('.app-map-location');
        BESSAppMapLocation.updateMapLocation(mapComponentNode, value.lat, value.lng);
    }
}
